import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=5aac79dc&scoped=true&"
import script from "./ShareLink.vue?vue&type=script&lang=ts&"
export * from "./ShareLink.vue?vue&type=script&lang=ts&"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=5aac79dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac79dc",
  null
  
)

export default component.exports